import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';

export const PAGINATION_STATE_KEY = 'paginationState';
export interface IPagination {
  numberOfPages: number;
  pageNumber: number;
  totalElements?: number;
}

@Component({
  standalone: false,
  selector: 'app-custom-pagination',
  templateUrl: './custom-pagination.component.html',
  styleUrls: ['./custom-pagination.component.scss'],
})
export class CustomPaginationComponent implements OnChanges {
  @Input() protected totalElements: number = 5000;
  @Input() numberOfPages: number = 50;
  @Input() pageOptions = [10, 50, 100, 200, 500];
  @Input() pageNumber: number = 0;

  @Output() public paginationEventEmitter: EventEmitter<IPagination> = new EventEmitter();

  isFlagged: boolean = true;

  currentPage: number;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.setFlag();
    if (changes?.totalElements?.currentValue) {
      this.totalElements = changes.totalElements.currentValue;
    }
    if (changes?.pageNumber?.currentValue || changes?.pageNumber?.currentValue == 0) {
      if (this.isFlagged) {
        this.setFlag();
      }
      setTimeout(() => {
        this.setFlag();
        this.currentPage = changes.pageNumber.currentValue + 1;
        this.cd.detectChanges();
      }, 100);
    }
  }

  pageChanged(event: PageChangedEvent) {
    if (this.isFlagged) return;
    this.pageNumber = event.page - 1;
    this.paginationEventEmitter.emit({
      numberOfPages: this.numberOfPages,
      pageNumber: this.pageNumber,
    });
  }

  getMoreItemsPerPage() {
    if (this.isFlagged) return;
    this.cd.detectChanges();
    this.currentPage = 1;
    this.cd.detectChanges();
    this.paginationEventEmitter.emit({
      numberOfPages: this.numberOfPages,
      pageNumber: this.pageNumber,
    });
  }

  setFlag() {
    this.isFlagged = true;
    setTimeout(() => {
      this.isFlagged = false;
    }, 100);
  }
}
